module.exports = __webpack_public_path__ + "static/media/pago9.ed53008e.svg";